import { Model } from '@vuex-orm/core'
import requestSerializer from 'aveine-toolbox/src/store/adapter/serializer'
import { Region } from 'aveine-toolbox'

/**
 * Une region proposee dans le profil de gout de l'app (REDMINE-13656).
 *
 * Sans region, c'est l'entree « Autres regions & vins du monde » : son libelle
 * est alors obligatoire en fr et en (CRUD-Wine). Avec une region, le libelle
 * est facultatif et remplace son nom dans l'app.
 */
export default class FeaturedRegion extends Model {
  static entity = 'featured_regions'

  static fields () {
    return {
      '$entity_name': this.attr(this.entity),
      'id': this.attr(null),
      'region': this.belongsTo(Region, 'region_id'), 'region_id': this.attr(null),
      'label': this.attr({}),
      'position': this.number(null).nullable(),
      'published': this.boolean(false),
      'created_at': this.string(),
      'updated_at': this.string(),
      'deleted': this.boolean(false)
    }
  }

  static readOnlyFields = ['region_id']

  static apiConfig = {
    transformRequest: (data) => {
      if (data) {
        return requestSerializer(this.entity, data)
      } else {
        return null
      }
    }
  }
}
